export const BEARER_TOKEN_STORAGE_KEY = 'authorization';
export const AUTH_EXPIRATION_TIME = 'expiration';
export const USER_LOGIN_STORAGE_KEY = 'login';